// Jakość kierowców z Bolt Fleet API 2.0 (29.10.2026): zawieszenia, oceny, anulowania, auto z Bolta.
const powodyPl = {
  traffic_jam: 'korek',
  other: 'inny powód',
  car_problems: 'problem z autem',
  client_asked_to_cancel: 'pasażer poprosił o anulowanie',
  missed_scheduled_ride_go_online_deadline: 'nie zdążył na zaplanowany kurs',
  system_cancelled: 'anulowane przez system',
  active_order_overlap_with_scheduled_ride: 'kolizja z zaplanowanym kursem',
  scheduled_ride_pickup_time_not_suitable: 'godzina zaplanowanego kursu nie pasowała',
  too_far_away_from_scheduled_pickup: 'za daleko od zaplanowanego odbioru',
  rejected_on_arrival_by_fraud: 'odrzucony na miejscu (podejrzenie oszustwa)',
  unknown: 'bez podanego powodu',
};

export const boltQualityPl = {
  title: 'Bolt',
  notChecked: 'Brak danych z Bolta (klucz Fleet API 2.0 nieustawiony albo kierowca nie ma ID Bolta).',
  checkedAt: 'Stan z Bolta: {date}',
  suspendedTitle: 'Zawieszony w Bolcie',
  suspendedSince: 'od {date}',
  boltStatus: { active: 'aktywny', suspended: 'zawieszony', deactivated: 'dezaktywowany' },
  ratingsTitle: 'Oceny i kursy (ostatnie 30 dni)',
  rating: 'Średnia ocena',
  ratingCount: '{count} ocen',
  previous: 'poprzednie 30 dni: {value}',
  noRatings: 'brak ocen',
  finished: 'Kursy zakończone',
  driverCancelled: 'Anulowane przez kierowcę',
  riderCancelled: 'Anulowane przez pasażera',
  noShow: 'Pasażer nie przyszedł',
  declining: { ponizej_progu: 'Ocena poniżej progu', spadek: 'Ocena wyraźnie spadła' },
  reasons: powodyPl,
  carTitle: 'Auto w Bolcie inne niż u nas',
  carText: 'W Bolcie jeździ autem {bolt}, u nas przypisane: {ours}.',
  carNone: 'brak',
  carAssign: 'Przypisz {plate}',
  carCompanyNote:
    'Auto firmowe: przypisanie oznacza czynsz najmu (u kierowcy rozliczanego jako najem) i obowiązek tygodniowego przebiegu przed wypłatą. Przy wydaniu auta lepiej zrobić protokół wydania.',
  carAssigned: 'Przypisano auto {plate}.',
  carAuto: 'Auto przypisane automatycznie z Bolta {date}.',
  // lista na stronie kierowców
  panelTitle: 'Bolt: oceny i zawieszenia',
  panelSummary: 'Spadająca ocena: {declining} · zawieszeni: {suspended}',
  panelEmpty: 'Brak kierowców ze spadającą oceną i zawieszonych w Bolcie.',
  panelThresholds: 'Na liście: średnia z 30 dni poniżej {rating} albo spadek o co najmniej {drop} względem poprzednich 30 dni (min. {min} ocen).',
  colDriver: 'Kierowca',
  colLast: '30 dni',
  colPrev: 'poprzednie 30 dni',
  colReason: 'Powód',
  suspendedList: 'Zawieszeni w Bolcie',
};

export const boltQualityEn = {
  title: 'Bolt',
  notChecked: 'No Bolt data (Fleet API 2.0 key not set or the driver has no Bolt ID).',
  checkedAt: 'Bolt status as of {date}',
  suspendedTitle: 'Suspended in Bolt',
  suspendedSince: 'since {date}',
  boltStatus: { active: 'active', suspended: 'suspended', deactivated: 'deactivated' },
  ratingsTitle: 'Ratings and rides (last 30 days)',
  rating: 'Average rating',
  ratingCount: '{count} ratings',
  previous: 'previous 30 days: {value}',
  noRatings: 'no ratings',
  finished: 'Finished rides',
  driverCancelled: 'Cancelled by driver',
  riderCancelled: 'Cancelled by rider',
  noShow: 'Rider did not show',
  declining: { ponizej_progu: 'Rating below threshold', spadek: 'Rating dropped noticeably' },
  reasons: {
    traffic_jam: 'traffic jam',
    other: 'other',
    car_problems: 'car problems',
    client_asked_to_cancel: 'rider asked to cancel',
    missed_scheduled_ride_go_online_deadline: 'missed scheduled ride',
    system_cancelled: 'cancelled by system',
    active_order_overlap_with_scheduled_ride: 'overlap with scheduled ride',
    scheduled_ride_pickup_time_not_suitable: 'scheduled pickup time not suitable',
    too_far_away_from_scheduled_pickup: 'too far from scheduled pickup',
    rejected_on_arrival_by_fraud: 'rejected on arrival (fraud)',
    unknown: 'no reason given',
  },
  carTitle: 'Car in Bolt differs from ours',
  carText: 'In Bolt the driver uses {bolt}; assigned here: {ours}.',
  carNone: 'none',
  carAssign: 'Assign {plate}',
  carCompanyNote:
    'Company car: assigning it means rent (for drivers settled as rent) and a weekly odometer reading before payout. Prefer a handover protocol.',
  carAssigned: 'Car {plate} assigned.',
  carAuto: 'Car assigned automatically from Bolt on {date}.',
  panelTitle: 'Bolt: ratings and suspensions',
  panelSummary: 'Declining rating: {declining} · suspended: {suspended}',
  panelEmpty: 'No drivers with a declining rating or suspended in Bolt.',
  panelThresholds: 'Listed: 30-day average below {rating} or a drop of at least {drop} vs the previous 30 days (min. {min} ratings).',
  colDriver: 'Driver',
  colLast: '30 days',
  colPrev: 'previous 30 days',
  colReason: 'Reason',
  suspendedList: 'Suspended in Bolt',
};
